// objectives

export const viewEditObjectiveDropdownValues = {
  editObjectives: [
    {
      label: 'None',
      value: 'NONE',
    },
    {
      label: 'Only Public',
      value: 'EDIT_PUBLIC_OBJECTIVE',
    },
    {
      label: 'All',
      value: 'EDIT_ALL_OBJECTIVE',
    },
  ],
  deleteObjectives: [
    {
      label: 'None',
      value: 'NONE',
    },
    {
      label: 'Only Public',
      value: 'DELETE_PUBLIC_OBJECTIVE',
    },
    {
      label: 'All',
      value: 'DELETE_ALL_OBJECTIVE',
    },
  ],
  updateStatusProgressObjectives: [
    {
      label: 'None',
      value: 'NONE',
    },
    {
      label: 'Only Public',
      value: 'UPDATE_PUBLIC_OBJECTIVE_STATUS_PROGRESS',
    },
    {
      label: 'All',
      value: 'UPDATE_ALL_OBJECTIVE_STATUS_PROGRESS',
    },
  ],
  viewCommentObjectives: [
    {
      label: 'None',
      value: 'NONE',
    },
    {
      label: 'Only Public',
      value: 'VIEW_COMMENT_PUBLIC_OBJECTIVES',
    },
    {
      label: 'All',
      value: 'VIEW_COMMENT_ALL_OBJECTIVES',
    },
  ],
};

// key results
export const viewEditKeyResultDropdownValues = {
  editKeyResults: [
    {
      label: 'None',
      value: 'NONE',
    },
    {
      label: 'Only Public',
      value: 'EDIT_PUBLIC_KEY_RESULT',
    },
    {
      label: 'All',
      value: 'EDIT_ALL_KEY_RESULT',
    },
  ],
  deleteKeyResults: [
    {
      label: 'None',
      value: 'NONE',
    },
    {
      label: 'Only Public',
      value: 'DELETE_PUBLIC_KEY_RESULT',
    },
    {
      label: 'All',
      value: 'DELETE_ALL_KEY_RESULT',
    },
  ],
  updateStatusProgressKeyResults: [
    {
      label: 'None',
      value: 'NONE',
    },
    {
      label: 'Only Public',
      value: 'UPDATE_PUBLIC_KEY_RESULT_STATUS_PROGRESS',
    },
    {
      label: 'All',
      value: 'UPDATE_ALL_KEY_RESULT_STATUS_PROGRESS',
    },
  ],
  viewCommentKeyResults: [
    {
      label: 'None',
      value: 'NONE',
    },
    {
      label: 'Only Public',
      value: 'VIEW_COMMENT_PUBLIC_KEY_RESULTS',
    },
    {
      label: 'All',
      value: 'VIEW_COMMENT_ALL_KEY_RESULTS',
    },
  ],
};

// initiatives
export const viewEditInitiativeDropdownValues = {
  editInitiatives: [
    {
      label: 'None',
      value: 'NONE',
    },
    {
      label: 'Only Public',
      value: 'EDIT_PUBLIC_INITIATIVE',
    },
    {
      label: 'All',
      value: 'EDIT_ALL_INITIATIVE',
    },
  ],
  deleteInitiatives: [
    {
      label: 'None',
      value: 'NONE',
    },
    {
      label: 'Only Public',
      value: 'DELETE_PUBLIC_INITIATIVE',
    },
    {
      label: 'All',
      value: 'DELETE_ALL_INITIATIVE',
    },
  ],
  updateStatusProgressInitiatives: [
    {
      label: 'None',
      value: 'NONE',
    },
    {
      label: 'Only Public',
      value: 'UPDATE_PUBLIC_INITIATIVE_STATUS_PROGRESS',
    },
    {
      label: 'All',
      value: 'UPDATE_ALL_INITIATIVE_STATUS_PROGRESS',
    },
  ],
  viewCommentInitiatives: [
    {
      label: 'None',
      value: 'NONE',
    },
    {
      label: 'Only Public',
      value: 'VIEW_COMMENT_PUBLIC_INITIATIVES',
    },
    {
      label: 'All',
      value: 'VIEW_COMMENT_ALL_INITIATIVES',
    },
  ],
};
